import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import { push } from 'react-router-redux';

import { loginRoutine } from '../../../routines';

import { authService } from '../../../sagas/authentication';

import styles from './styles';

class Callback extends Component {
  static propTypes = {
    push: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div style={styles.container}>
        <img alt="Logo" src="/images/logo.png"/>
        <div>Processing...</div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    push,
  }, dispatch);
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Callback);



// WEBPACK FOOTER //
// ./src/components/Authentication/Callback/index.js